//
// Module for the Benefit Estimate wizard's Projections step
//
rs.module("participant/benefit/estimates/create/wizard/projectionsstep",

    [ ],

    function () {

        // Initialize the module
        function initialize(jsSelectors, salaryIncreasesGrid) {

            // get JS selectors
            var stepContainer = $.js(jsSelectors.stepContainer);
            var addSalaryIncreaseLink = stepContainer.js(jsSelectors.addSalaryIncreaseLink);

            // add grid row to Salary Increases grid for inline editing
            addSalaryIncreaseLink.on("click", function () {
                salaryIncreasesGrid.addRow();
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);